<template lang="pug">
  .roles__list
    template(
      v-for="role in availableRoles"
    )
      p.role__item(
        :class="{'role__item_active': isActiveRole(role.name)}"
        v-text="role.name"
        :key="role.id"
        @click="(event) => handleClickRole(event, role.name)"
      )
</template>

<script>
import {
  ADD_ROLES,
  REMOVE_ROLES,
} from '../constants';

export default {
  name: 'RolesList',

  props: {
    allRoles: {
      type: Object,
      required: true,
    },

    appName: {
      type: String,
      required: true,
    },

    sub: {
      type: Number,
      required: true,
    },

    availableRoles: {
      type: Array,
      required: true,
    },
  },

  methods: {
    handleClickRole(event, role) {
      event.target.classList.toggle('role__item_active');

      const payload = {
        sub: this.sub,
        appName: this.appName,
        roles: [role],
      };

      const isActive = this.isActiveRole(role);

      if (isActive) {
        this.$store.dispatch(REMOVE_ROLES, payload);
      } else {
        this.$store.dispatch(ADD_ROLES, payload);
      }
    },

    isActiveRole(role) {
      let i = 0;
      if (this.allRoles && this.allRoles[this.appName] && this.allRoles[this.appName].length) {
        this.allRoles[this.appName].forEach((item) => {
          if (item === role) i += 1;
        });
      }
      return i > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  .roles__list {
    display: flex;
    flex-wrap: wrap;
    max-width: 100%;
  }

  .role__item {
    background-color: #e0e0e0;
    color: #757575;
    cursor: pointer;
    border-radius: 11px;
    padding: 0 17px;
    margin-right: 8px;
    margin-bottom: 10px;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    padding-top: 2px;
    min-height: 24px;

    @include hover {
      opacity: 0.8;
    }

    @include mobile {
      padding: 3px 12px;
      font-size: 14px;
    }

    &_active {
      color: white;
    }

    &_active:nth-child(1) {
      background-color: #2e7d32;
    }

    &_active:nth-child(2) {
      background-color: #283593;
    }

    &_active:nth-child(3) {
      background-color: #880e4f;
    }

    &_active:nth-child(4) {
      background-color: red;
    }

    &_active:nth-child(5) {
      background-color: orange;
    }

    &_active:nth-child(6) {
      background-color: plum;
    }

    &_active:nth-child(7) {
      background-color: blue;
    }

    &_active:nth-child(8) {
      background-color: brown;
    }

    &_active:nth-child(9) {
      background-color: sandybrown;
    }

    &_active:nth-child(10) {
      background-color: fuchsia;
    }

    &_active:nth-child(11) {
      background-color: lightcoral;
    }

    &_active:nth-child(12) {
      background-color: yellowgreen;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RolesList.vue